import React, { useEffect, useState } from 'react'
import { postService, clientService } from '@services/api'
import apiClient from '@services/api/client'
import toast from 'react-hot-toast'
import AdminLayout from '../../layouts/AdminLayout'
import { useAuthStore } from '@store'

const storageURL = import.meta.env.VITE_STORAGE_URL || 'http://localhost:84/storage'
const mediaUrl = (p) => { if (!p) return null; let s = String(p); const i = s.indexOf('/storage/'); if (i !== -1) s = s.slice(i + 9); return storageURL + '/' + s.replace(/^\/+/, '') }

const mapBanner = (p) => {
  // Calcule la durée réelle depuis les dates (IndicePeriode peut être invalide)
  const computedDuration = (() => {
    if (p.DateFinPost && p.created_at) {
      const days = Math.round((new Date(p.DateFinPost) - new Date(p.created_at)) / (1000 * 60 * 60 * 24))
      if (days > 0) return String(days)
    }
    const raw = parseInt(p.IndicePeriode || p.indiceperiode || 0)
    return String(raw > 0 ? raw : 30)
  })()
  const clientName = p.client ? [p.client.nom, p.client.prenom].filter(Boolean).join(' ') : ''
  const imageUrl = p.fichiers?.[0]?.chemin ? mediaUrl(p.fichiers[0].chemin) : null
  return ({
    id: p.post_id,
    title: p.libele,
    description: p.description,
    website_url: p.siteWeb || '',
    // Alias pour la liste (image_url, advertiser, starts_at)
    image: imageUrl,
    image_url: imageUrl,
    advertiser: clientName || '',
    advertiser_phone: p.client?.numero || '',
    starts_at: p.DateDebutPost || p.created_at || null,
    views: p.vues || 0,
    status: p.status,
    created_at: p.created_at,
    expires_at: p.DateFinPost || null,
    duration: computedDuration,
    position: String(p.position || p.apartir_de || '1'),
    client_id: p.post_client_id || '',
    client_type: p.external_client_id ? 'external' : 'existing',
    external_client_name: p.external_client_id ? clientName : '',
    external_client_phone: p.external_client_id ? (p.client?.numero || '') : '',
    client_name: clientName,
    client_phone: p.client?.numero || '',
    post_staff_id: p.post_staff_id,
  })
}

const AdminBannersPage = () => {
  const { user } = useAuthStore()
  const [banners, setBanners] = useState([])
  const [loading, setLoading] = useState(true)
  const [searchTerm, setSearchTerm] = useState('')
  const [filterStatus, setFilterStatus] = useState('all') // all, active, expired
  const [sortBy, setSortBy] = useState('date_desc')
  const [showModal, setShowModal] = useState(false)
  const [showEditModal, setShowEditModal] = useState(false)
  const [showViewModal, setShowViewModal] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [showArchiveModal, setShowArchiveModal] = useState(false)
  const [selectedBanner, setSelectedBanner] = useState(null)
  const [archiveAction, setArchiveAction] = useState(null) // 'archive' ou 'unarchive'
  const [clients, setClients] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage] = useState(6) // 6 bannières par page
  const [selectedBanners, setSelectedBanners] = useState([])
  const [selectAll, setSelectAll] = useState(false)

  // Récupérer les rôles de l'utilisateur
  const getCurrentUserRoles = () => {
    const storedUser = localStorage.getItem('admin_user') || localStorage.getItem('user')
    if (!storedUser) return []
    try {
      const userData = JSON.parse(storedUser)
      const normalize = (r) => (typeof r === 'string' ? r : r?.name ?? '')
      if (Array.isArray(userData.roles)) return userData.roles.map(normalize)
      if (typeof userData.roles === 'string') return userData.roles.split(',').map(r => r.trim())
      if (userData.role) return [normalize(userData.role)]
    } catch (e) {}
    return []
  }

  const userRoles = getCurrentUserRoles()
  const n = (r) => r.toLowerCase()
  const isSuperAdmin = userRoles.length === 0 || userRoles.some(r => n(r) === 'super admin')
  const isAdmin = userRoles.some(r => n(r) === 'admin')
  const isSuperviseur = userRoles.some(r => n(r) === 'superviseur')
  const isAnimateur = userRoles.some(r => n(r) === 'animateur')
  const isTechnicien = userRoles.some(r => n(r) === 'technicien')
  const isClient = userRoles.some(r => n(r) === 'client')

  // Récupérer l'ID du client connecté
  const getUserId = () => {
    if (user?.users_id) return user.users_id
    if (user?.client_id) return user.client_id
    if (user?.id) return user.id
    if (user?.user_id) return user.user_id

    try {
      const storedUser = localStorage.getItem('kudhi_user') || localStorage.getItem('admin_user') || localStorage.getItem('user')
      if (storedUser) {
        const userData = JSON.parse(storedUser)
        return userData.users_id || userData.client_id || userData.id || userData.user_id
      }
    } catch (e) {
      console.error('Erreur parsing user from localStorage:', e)
    }
    return null
  }
  
  const currentClientId = getUserId()

  console.log('📌 CurrentClientId Debug:', {
    user,
    currentClientId,
    localStorage: localStorage.getItem('admin_user') || localStorage.getItem('user')
  })

  // Fonction pour vérifier si l'utilisateur est propriétaire de la bannière
  const isOwner = (banner) => {
    console.log('🔍 isOwner Check:', {
      bannerId: banner.id,
      bannerTitle: banner.title,
      post_staff_id: banner.post_staff_id,
      currentClientId,
      isClient,
      isAnimateur,
      comparison: banner.post_staff_id === currentClientId,
      stringComparison: banner.post_staff_id === String(currentClientId)
    })
    
    // Pour les clients: vérifier si c'est leur propre bannière
    if (isClient) {
      return banner.client_id === currentClientId || banner.client_id === String(currentClientId)
    }
    // Pour les staff (Animateur, etc.): vérifier si c'est eux qui ont créé la bannière
    // Vérifier post_staff_id (ID du créateur staff)
    return banner.post_staff_id === currentClientId || 
           banner.post_staff_id === String(currentClientId) ||
           Number(banner.post_staff_id) === Number(currentClientId)
  }

  // Permissions pour les boutons d'actions (fonction dynamique par bannière)
  const getPermissions = (banner) => {
    console.log('🔐 getPermissions Debug:', {
      bannerId: banner.id,
      bannerTitle: banner.title,
      isSuperAdmin,
      isAdmin,
      isSuperviseur,
      isOwner: isOwner(banner),
      userRoles
    })
    
    // Super Admin et Admin ont TOUS les droits sur TOUTES les bannières
    if (isSuperAdmin || isAdmin) {
      return {
        canView: true,
        canEdit: true,
        canArchive: true,
        canDelete: true // Vraie suppression pour Super Admin/Admin
      }
    }

    // Superviseur : peut voir, modifier et archiver toutes les bannières
    if (isSuperviseur) {
      return {
        canView: true,
        canEdit: true,
        canArchive: true,
        canDelete: false
      }
    }

    // Autres rôles (Animateur, Technicien, Client) : 
    // 3 boutons sur leurs propres bannières (Voir, Modifier, Supprimer)
    // Le bouton "Supprimer" agit comme "Archiver" pour les non-Admin
    if (isOwner(banner)) {
      return {
        canView: true,
        canEdit: true,
        canArchive: false, // Pas de bouton "Archiver" séparé
        canDelete: true    // Bouton "Supprimer" qui archive au lieu de supprimer
      }
    }

    // Par défaut : lecture seule
    return {
      canView: true,
      canEdit: false,
      canArchive: false,
      canDelete: false
    }
  }
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    website_url: '',
    client_id: '',
    client_type: 'existing', // 'existing' ou 'external'
    external_client_name: '',
    external_client_phone: '',
    duration: '30', // Durée en jours
    position: '1', // Position de la bannière
    image: null
  })

  useEffect(() => {
    loadBanners()
    loadClients()

    // Écouter l'événement d'ouverture du modal depuis le layout
    const handleOpenModal = () => setShowModal(true)
    window.addEventListener('openAddBannerModal', handleOpenModal)

    return () => {
      window.removeEventListener('openAddBannerModal', handleOpenModal)
    }
  }, [])

  // Réinitialiser à la page 1 quand les filtres changent
  useEffect(() => {
    setCurrentPage(1)
  }, [searchTerm, filterStatus, sortBy])

  const loadBanners = async () => {
    try {
      // Charger uniquement les bannières avec post_staff_id (créées par le staff)
      // Super Admin et Admin voient TOUTES les bannières staff
      // Autres utilisateurs voient uniquement leurs propres bannières staff
      console.log('🔍 Load Banners Debug:', {
        isSuperAdmin,
        isAdmin,
        isClient,
        currentClientId,
        userRoles,
        user
      })

      const params = {
        type: 3,
        staff_only: 1,
        ...( (!isSuperAdmin && !isAdmin) ? { post_staff: currentClientId } : {} )
      }

      const result = await postService.getPosts(params)
      setBanners((result?.data || []).map(mapBanner))
    } catch (error) {
      console.error('Error loading banners:', error)
    } finally {
      setLoading(false)
    }
  }

  const loadClients = async () => {
    try {
      const result = await clientService.getClients()
      setClients(result.data || [])
    } catch (error) {
      console.error('Error loading clients:', error)
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    try {
      // Validation client
      if (formData.client_type === 'existing' && !formData.client_id) {
        toast.error('Veuillez sélectionner un client')
        return
      }
      if (formData.client_type === 'external' && (!formData.external_client_name || !formData.external_client_phone)) {
        toast.error('Veuillez remplir les informations du client externe')
        return
      }

      const formDataToSend = new FormData()
      formDataToSend.append('libele', formData.title)
      formDataToSend.append('description', formData.description)
      formDataToSend.append('link', formData.website_url)
      formDataToSend.append('type', '3')
      formDataToSend.append('duration', formData.duration)
      formDataToSend.append('position', formData.position)
      formDataToSend.append('from_admin_panel', '1')

      // Client associé à la bannière
      formDataToSend.append('post_client_id', formData.client_id)

      if (formData.client_type === 'external') {
        formDataToSend.append('external_client', '1')
        formDataToSend.append('external_client_name', formData.external_client_name)
        formDataToSend.append('external_client_phone', formData.external_client_phone)
      }

      // Image
      if (formData.image) {
        formDataToSend.append('files[]', formData.image)
      }

      // Marquer comme publication staff pour qu'elle apparaisse dans le sidebar
      const staffCreatorId = user?.client_id || user?.id
      if (staffCreatorId) {
        formDataToSend.append('staff_creator_id', staffCreatorId)
      }

      const result = await postService.createPost(formDataToSend)

      if (result) {
        toast.success('✨ Bannière créée avec succès!')
        setShowModal(false)
        loadBanners()
        // Réinitialiser le formulaire
        setFormData({
          title: '',
          description: '',
          website_url: '',
          client_id: '',
          client_type: 'existing',
          external_client_name: '',
          external_client_phone: '',
          duration: '30',
          position: '1',
          image: null
        })
      }
    } catch (error) {
      console.error('Error creating banner:', error)
      toast.error(error.response?.data?.message || 'Erreur lors de la création de la bannière')
    }
  }

  const handleImageChange = (e) => {
    const file = e.target.files[0]
    if (file) {
      setFormData({ ...formData, image: file })
    }
  }

  const handleEditClick = (banner) => {
    setSelectedBanner(banner)
    setFormData({
      title: banner.title || '',
      description: banner.description || '',
      website_url: banner.website_url || '',
      client_id: banner.client_id || '',
      client_type: banner.client_type || 'existing',
      external_client_name: banner.external_client_name || '',
      external_client_phone: banner.external_client_phone || '',
      duration: banner.duration || '30',
      position: banner.position || '1',
      image: null
    })
    setShowEditModal(true)
  }


  const handleUpdate = async (e) => {
    e.preventDefault()
    console.log('[handleUpdate] formData=', JSON.stringify({ client_type: formData.client_type, client_id: formData.client_id, title: formData.title }))

    try {
      const appendClient = (fd) => {
        if (formData.client_type === 'existing') {
          const cid = formData.client_id || ''
          fd.append('client_id', cid)
          fd.append('post_client_id', cid)
        } else {
          fd.append('external_client', '1')
          fd.append('external_client_name', formData.external_client_name || '')
          fd.append('external_client_phone', formData.external_client_phone || '')
        }
      }

      if (formData.image) {
        const fd = new FormData()
        fd.append('_method', 'PUT')
        fd.append('title', formData.title)
        fd.append('libele', formData.title)
        fd.append('description', formData.description)
        fd.append('siteWeb', formData.website_url)
        fd.append('link', formData.website_url)
        fd.append('duration', formData.duration)
        fd.append('position', formData.position)
        fd.append('files[]', formData.image)
        appendClient(fd)
        await apiClient.post(`/posts/${selectedBanner.id}`, fd, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
      } else {
        const clientPayload = formData.client_type === 'existing'
          ? { client_id: formData.client_id || '', post_client_id: formData.client_id || '' }
          : { external_client: 1, external_client_name: formData.external_client_name, external_client_phone: formData.external_client_phone }

        await postService.updatePost(selectedBanner.id, {
          title: formData.title,
          libele: formData.title,
          description: formData.description,
          siteWeb: formData.website_url,
          link: formData.website_url,
          duration: formData.duration,
          position: formData.position,
          ...clientPayload,
        })
      }
      toast.success('✅ Bannière modifiée avec succès!')
      setShowEditModal(false)
      setSelectedBanner(null)
      loadBanners()
    } catch (error) {
      console.error('Error updating banner:', error)
      toast.error(error.response?.data?.message || 'Erreur lors de la modification')
    }
  }

  const handleDelete = async () => {
    if (!selectedBanner) return

    try {
      // Si l'utilisateur est Super Admin ou Admin, vraie suppression
      // Sinon, archivage (status = 2) - mais l'utilisateur croit que c'est une suppression
      if (isSuperAdmin || isAdmin) {
        await postService.deletePost(selectedBanner.id)
        toast.success('🗑️ Bannière supprimée avec succès')
        setShowDeleteModal(false)
        setSelectedBanner(null)
        loadBanners()
      } else {
        // Pour les autres utilisateurs : archivage au lieu de suppression (invisible pour eux)
        await postService.archivePost(selectedBanner.id)
        toast.success('🗑️ Bannière supprimée avec succès')
        setShowDeleteModal(false)
        setSelectedBanner(null)

        // Mettre à jour immédiatement le state local
        setBanners(prevBanners =>
          prevBanners.map(b =>
            b.id === selectedBanner.id
              ? { ...b, status: 2 }
              : b
          )
        )

        // Recharger après un court délai
        setTimeout(() => {
          loadBanners()
        }, 300)
      }
    } catch (error) {
      console.error('Error deleting/archiving banner:', error)
      toast.error(error.response?.data?.message || 'Erreur lors de la suppression')
    }
  }

  const openViewModal = (banner) => {
    setSelectedBanner(banner)
    setShowViewModal(true)
  }

  const openDeleteModal = (banner) => {
    setSelectedBanner(banner)
    setShowDeleteModal(true)
  }

  const handleDeleteClick = async (bannerId) => {
    const banner = banners.find(b => b.id === bannerId)
    openDeleteModal(banner)
  }

  const handleArchiveClick = (banner, isActive) => {
    setSelectedBanner(banner)
    setArchiveAction(isActive ? 'archive' : 'unarchive')
    setShowArchiveModal(true)
  }

  const confirmArchive = async () => {
    if (!selectedBanner || !archiveAction) return

    const currentStatus = archiveAction === 'archive'

    try {
      await postService.archivePost(selectedBanner.id)
      toast.success(`✅ Bannière ${currentStatus ? 'archivée' : 'désarchivée'} avec succès`)
      setShowArchiveModal(false)
      setSelectedBanner(null)
      setArchiveAction(null)

      // Mettre à jour immédiatement le state local pour un feedback instantané
      setBanners(prevBanners =>
        prevBanners.map(b =>
          b.id === selectedBanner.id
            ? { ...b, status: currentStatus === 3 ? 2 : 3 }
            : b
        )
      )
      // Recharger les données de l'API après un court délai
      setTimeout(() => {
        loadBanners()
      }, 300)
    } catch (error) {
      console.error('Error toggling banner status:', error)
      toast.error(error.response?.data?.message || 'Erreur lors de la modification du statut')
    }
  }

  const filteredBanners = banners.filter(banner => {
    const matchesSearch = banner.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         banner.client_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         banner.description?.toLowerCase().includes(searchTerm.toLowerCase())
    
    let matchesStatus = true
    if (filterStatus === 'active') {
      const isExpired = banner.expires_at ? new Date(banner.expires_at) < new Date() : false
      matchesStatus = banner.status !== 2 && !isExpired
    } else if (filterStatus === 'expired') {
      const isExpired = banner.expires_at ? new Date(banner.expires_at) < new Date() : false
      matchesStatus = banner.status !== 2 && isExpired
    } else if (filterStatus === 'archived') {
      matchesStatus = banner.status === 3
    }
    
    return matchesSearch && matchesStatus
  })
  
  // Appliquer le tri
  const sortedBanners = [...filteredBanners].sort((a, b) => {
    switch (sortBy) {
      case 'date_desc':
        return new Date(b.created_at || 0) - new Date(a.created_at || 0)
      case 'date_asc':
        return new Date(a.created_at || 0) - new Date(b.created_at || 0)
      case 'name_asc':
        return (a.name || '').localeCompare(b.name || '')
      case 'name_desc':
        return (b.name || '').localeCompare(a.name || '')
      case 'views_desc':
        return (b.views || 0) - (a.views || 0)
      case 'views_asc':
        return (a.views || 0) - (b.views || 0)
      default:
        return 0
    }
  })

  console.log('🔎 Filter Debug:', {
    totalBanners: banners.length,
    filteredCount: sortedBanners.length,
    filterStatus,
    searchTerm,
    archivedBanners: banners.filter(b => b.status === 3).length
  })

  // Pagination
  const totalPages = Math.ceil(sortedBanners.length / itemsPerPage)
  const startIndex = (currentPage - 1) * itemsPerPage
  const endIndex = startIndex + itemsPerPage
  const currentBanners = sortedBanners.slice(startIndex, endIndex)

  if (loading) {
    return (
      <AdminLayout>
        <div className="flex items-center justify-center h-full">
          <div className="text-gray-400 text-lg">Chargement...</div>
        </div>
      </AdminLayout>
    )
  }

  return (
    <AdminLayout>
      <div className="space-y-6 mt-10">
        {/* Header */}
        <div className="bg-white rounded-md border border-slate-200 p-8">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-semibold text-gray-800">Bannières Publicitaires</h1>
              <p className="text-gray-500 mt-2 flex items-center gap-2">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z" />
                </svg>
                Gérer toutes les bannières publicitaires
              </p>
            </div>
            <button 
              onClick={() => setShowModal(true)}
              className="flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-[#FFD700] to-[#F5C800] text-[#002A4E] rounded-md transition-all font-medium"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z" />
              </svg>
              Nouvelle bannière
            </button>
          </div>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          {/* Total */}
          <div className="bg-white rounded-md p-6 border border-slate-200 transition-shadow">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-500 font-medium mb-1">Total</p>
                <p className="text-2xl font-bold text-gray-800">{banners.length}</p>
              </div>
              <div className="w-12 h-12 bg-orange-50 rounded-md flex items-center justify-center">
                <svg className="w-6 h-6 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z" />
                </svg>
              </div>
            </div>
          </div>

          {/* Actives */}
          <div className="bg-white rounded-md p-6 border border-slate-200 transition-shadow">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-500 font-medium mb-1">Actives</p>
                <p className="text-2xl font-bold text-green-600">
                  {banners.filter(b => {
                    if (b.status === 3) return false; // Archivée
                    const isExpired = b.expires_at ? new Date(b.expires_at) < new Date() : false;
                    return !isExpired; // Active si pas archivée et pas expirée
                  }).length}
                </p>
              </div>
              <div className="w-12 h-12 bg-green-50 rounded-md flex items-center justify-center">
                <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
            </div>
          </div>

          {/* Expirées */}
          <div className="bg-white rounded-md p-6 border border-slate-200 transition-shadow">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-500 font-medium mb-1">Expirées</p>
                <p className="text-2xl font-bold text-red-600">
                  {banners.filter(b => {
                    if (b.status === 3) return false; // Archivée
                    const isExpired = b.expires_at ? new Date(b.expires_at) < new Date() : false;
                    return isExpired; // Expirée si pas archivée et date dépassée
                  }).length}
                </p>
              </div>
              <div className="w-12 h-12 bg-red-50 rounded-md flex items-center justify-center">
                <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
            </div>
          </div>

          {/* Archivées */}
          <div className="bg-white rounded-md p-6 border border-slate-200 transition-shadow">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-500 font-medium mb-1">Archivées</p>
                <p className="text-2xl font-bold text-gray-600">
                  {banners.filter(b => b.status === 3).length}
                </p>
              </div>
              <div className="w-12 h-12 bg-gray-50 rounded-md flex items-center justify-center">
                <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" />
                </svg>
              </div>
            </div>
          </div>
        </div>

        {/* Filtres */}
        <div className="bg-white rounded-md p-6 border border-slate-200">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <div className="relative md:col-span-2 lg:col-span-1">
              <svg className="absolute left-3 top-3.5 w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
              <input
                type="text"
                placeholder="Rechercher par titre ou annonceur..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-10 pr-4 py-3 border border-gray-200 rounded-md focus:ring-2 focus:ring-amber-200 focus:border-transparent transition-all"
              />
            </div>

            <select
              value={filterStatus}
              onChange={(e) => setFilterStatus(e.target.value)}
              className="px-4 py-3 border border-slate-200 rounded-md focus:ring-2 focus:ring-amber-200 focus:border-transparent bg-white transition-all"
            >
              <option value="all">Tous les statuts</option>
              <option value="active">✓ Actives</option>
              <option value="expired">⏰ Expirées</option>
              <option value="archived">📦 Archivées</option>
            </select>

            <select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              className="px-4 py-3 border border-slate-200 rounded-md focus:ring-2 focus:ring-amber-200 focus:border-transparent bg-white transition-all"
            >
              <option value="date_desc">📅 Plus récentes</option>
              <option value="date_asc">📅 Plus anciennes</option>
              <option value="name_asc">🔤 Titre A-Z</option>
              <option value="name_desc">🔤 Titre Z-A</option>
              <option value="views_desc">👁️ Plus de vues</option>
              <option value="views_asc">👁️ Moins de vues</option>
            </select>
          </div>
        </div>

        {/* Table des bannières */}
        <div className="bg-white rounded-md border border-slate-200 overflow-hidden">
          <div className="px-6 py-4 border-b border-gray-100">
            <div className="flex items-center justify-between">
              <h2 className="text-lg font-semibold text-gray-800">Liste des bannières</h2>
              <span className="text-sm text-gray-500">{sortedBanners.length} bannière{sortedBanners.length > 1 ? 's' : ''}</span>
            </div>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50 border-b border-gray-100">
                <tr>
                  <th className="px-6 py-3">
                    <input
                      type="checkbox"
                      checked={selectAll}
                      onChange={(e) => {
                        setSelectAll(e.target.checked)
                        if (e.target.checked) {
                          setSelectedBanners(currentBanners.map(b => b.id))
                        } else {
                          setSelectedBanners([])
                        }
                      }}
                      className="w-4 h-4 text-[#002A4E] border-gray-300 rounded focus:ring-2 focus:ring-amber-200 cursor-pointer"
                    />
                  </th>
                  <th className="text-left px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Image</th>
                  <th className="text-left px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Titre</th>
                  <th className="text-left px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Annonceur</th>
                  <th className="text-left px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Statut</th>
                  <th className="text-left px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Date création</th>
                  <th className="text-left px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Date fin</th>
                  <th className="text-left px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Durée</th>
                  <th className="text-left px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Jours restants</th>
                  <th className="text-left px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Vues</th>
                  <th className="text-right px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {currentBanners.map((banner, index) => {
                  const isActive = banner.status === 3
                  const isArchived = banner.status === 3
                  
                  // Vérifier si la bannière est expirée en fonction de la date
                  const isExpired = banner.expires_at ? new Date(banner.expires_at) < new Date() : false
                  
                  return (
                    <tr key={banner.id} className={`hover:bg-gray-50 transition-colors border-b border-gray-50 last:border-0 ${
                      isArchived ? 'bg-gray-100 opacity-60' : ''
                    }`}>
                      <td className="px-6 py-4">
                        <input
                          type="checkbox"
                          checked={selectedBanners.includes(banner.id)}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setSelectedBanners([...selectedBanners, banner.id])
                            } else {
                              setSelectedBanners(selectedBanners.filter(id => id !== banner.id))
                              setSelectAll(false)
                            }
                          }}
                          className="w-4 h-4 text-[#002A4E] border-gray-300 rounded focus:ring-2 focus:ring-amber-200 cursor-pointer"
                        />
                      </td>
                      <td className="px-6 py-4">
                        {banner.image_url ? (
                          <img
                            src={banner.image_url}
                            alt={banner.title}
                            className="w-20 h-12 object-cover rounded-md "
                            onError={(e) => {
                              e.target.style.display = 'none'
                              e.target.nextSibling.style.display = 'flex'
                            }}
                          />
                        ) : null}
                        <div className={`w-20 h-12 bg-gradient-to-br from-gray-100 to-gray-200 rounded-md flex items-center justify-center ${banner.image_url ? 'hidden' : ''}`}>
                          <svg className="w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                          </svg>
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <p className="font-medium text-gray-800">
                          {banner.title || banner.titre || 'Sans titre'}
                        </p>
                      </td>
                      <td className="px-6 py-4">
                        <p className="text-gray-700">
                          {banner.advertiser || 'N/A'}
                        </p>
                        {banner.advertiser_phone && (
                          <p className="text-xs text-gray-500">{banner.advertiser_phone}</p>
                        )}
                      </td>
                      <td className="px-6 py-4">
                        {isArchived ? (
                          <span className="px-3 py-1 bg-red-100 text-red-700 rounded-full text-xs font-medium flex items-center gap-1 w-fit">
                            <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                              <path d="M4 3a2 2 0 100 4h12a2 2 0 100-4H4z" />
                              <path fillRule="evenodd" d="M3 8h14v7a2 2 0 01-2 2H5a2 2 0 01-2-2V8zm5 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z" clipRule="evenodd" />
                            </svg>
                            Archivée
                          </span>
                        ) : isExpired ? (
                          <span className="px-3 py-1 bg-red-100 text-red-700 rounded-full text-xs font-medium flex items-center gap-1 w-fit">
                            <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                            </svg>
                            Expirée
                          </span>
                        ) : (
                          <span className="px-3 py-1 bg-green-100 text-green-700 rounded-full text-xs font-medium flex items-center gap-1 w-fit">
                            <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                            </svg>
                            Active
                          </span>
                        )}
                      </td>
                      <td className="px-6 py-4">
                        <span className="text-sm text-gray-600">
                          {banner.created_at ? new Date(banner.created_at).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' }) : 'N/A'}
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        <span className="text-sm text-gray-600">
                          {banner.expires_at ? new Date(banner.expires_at).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' }) : 'N/A'}
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        {banner.starts_at && banner.expires_at ? (() => {
                          const startDate = new Date(banner.starts_at);
                          const endDate = new Date(banner.expires_at);
                          const diffTime = endDate - startDate;
                          const totalDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                          return <span className="px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-xs font-medium">{totalDays} jour{totalDays > 1 ? 's' : ''}</span>;
                        })() : <span className="text-sm text-gray-400">N/A</span>}
                      </td>
                      <td className="px-6 py-4">
                        {banner.expires_at ? (() => {
                          const now = new Date();
                          const expiryDate = new Date(banner.expires_at);
                          const diffTime = expiryDate - now;
                          const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
                          
                          if (diffDays < 0) {
                            return <span className="px-3 py-1.5 bg-red-100 text-red-700 rounded-full text-xs font-semibold inline-flex items-center gap-1">
                              <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                              </svg>
                              Expiré
                            </span>;
                          } else if (diffDays === 0) {
                            return <span className="px-3 py-1.5 bg-orange-100 text-orange-700 rounded-full text-xs font-semibold inline-flex items-center gap-1">
                              <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                              </svg>
                              Aujourd'hui
                            </span>;
                          } else if (diffDays === 1) {
                            return <span className="px-3 py-1.5 bg-orange-100 text-orange-700 rounded-full text-xs font-semibold inline-flex items-center gap-1">
                              <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                              </svg>
                              1 jour
                            </span>;
                          } else if (diffDays <= 7) {
                            return <span className="px-3 py-1.5 bg-orange-100 text-orange-700 rounded-full text-xs font-semibold inline-flex items-center gap-1">
                              <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                              </svg>
                              {diffDays} jours
                            </span>;
                          } else {
                            return <span className="px-3 py-1.5 bg-green-100 text-green-700 rounded-full text-xs font-semibold inline-flex items-center gap-1">
                              <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                              </svg>
                              {diffDays} jours
                            </span>;
                          }
                        })() : <span className="px-3 py-1.5 bg-gray-100 text-gray-600 rounded-full text-xs font-medium">N/A</span>}
                      </td>
                      <td className="px-6 py-4 text-gray-600">
                        <span className="flex items-center gap-1.5">
                          <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                          </svg>
                          {banner.views || 0}
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        <div className="flex items-center justify-end gap-2">
                          {getPermissions(banner).canView && (
                            <button 
                              onClick={() => openViewModal(banner)}
                              className="p-2 text-blue-600 hover:bg-blue-50 rounded-md transition-colors"
                              title="Voir"
                            >
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                              </svg>
                            </button>
                          )}
                          {getPermissions(banner).canEdit && (
                            <button 
                              onClick={() => handleEditClick(banner)}
                              className="p-2 text-green-600 hover:bg-green-50 rounded-md transition-colors"
                              title="Modifier"
                            >
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                              </svg>
                            </button>
                          )}
                          {getPermissions(banner).canArchive && (
                            <button 
                              onClick={() => handleArchiveClick(banner, isActive)}
                              className={`p-2 ${banner.status === 3 ? 'text-green-600 hover:bg-green-50' : 'text-orange-600 hover:bg-orange-50'} rounded-md transition-colors`}
                              title={banner.status === 3 ? 'Désarchiver' : 'Archiver'}
                            >
                              {banner.status === 3 ? (
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" />
                                </svg>
                              ) : (
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" />
                                </svg>
                              )}
                            </button>
                          )}
                          {getPermissions(banner).canDelete && (
                            <button 
                              onClick={() => handleDeleteClick(banner.id)}
                              className="p-2 text-red-600 hover:bg-red-50 rounded-md transition-colors"
                              title="Supprimer"
                            >
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                              </svg>
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>

            {sortedBanners.length === 0 && (
              <div className="text-center py-12 text-gray-500">
                <div className="text-6xl mb-4">📢</div>
                <p className="text-lg">Aucune bannière trouvée</p>
              </div>
            )}
          </div>

          {/* Pagination */}
          {sortedBanners.length > 0 && totalPages > 1 && (
            <div className="px-6 py-4 border-t border-gray-100 bg-gray-50">
              <div className="flex items-center justify-between">
                <div className="text-sm text-gray-600">
                  Affichage de {startIndex + 1} à {Math.min(endIndex, sortedBanners.length)} sur {sortedBanners.length} bannières
                </div>
                <div className="flex items-center gap-2">
                  <button
                    onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                    disabled={currentPage === 1}
                    className="px-3 py-2 border border-gray-300 rounded-md hover:bg-white transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                    </svg>
                  </button>
                  
                  <div className="flex items-center gap-1">
                    {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                      <button
                        key={page}
                        onClick={() => setCurrentPage(page)}
                        className={`px-4 py-2 rounded-md transition-colors ${
                          currentPage === page
                            ? 'bg-[#FFD700] text-[#002A4E] font-semibold'
                            : 'bg-white border border-gray-300 hover:bg-gray-50 text-gray-700'
                        }`}
                      >
                        {page}
                      </button>
                    ))}
                  </div>

                  <button
                    onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
                    disabled={currentPage === totalPages}
                    className="px-3 py-2 border border-gray-300 rounded-md hover:bg-white transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Modal de création */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 animate-fadeIn">
          <div className="bg-white rounded-md max-w-3xl w-full max-h-[90vh] flex flex-col animate-scaleIn border border-slate-200">
            {/* Header - Fixed */}
            <div className="p-6 border-b border-gray-200 flex items-center justify-between flex-shrink-0 rounded-t-md">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-gradient-to-br from-[#FFD700] to-[#F5C800] rounded-md flex items-center justify-center">
                  <svg className="w-6 h-6 text-[#002A4E]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                  </svg>
                </div>
                <h2 className="text-2xl font-bold text-gray-800">Créer une bannière publicitaire</h2>
              </div>
              <button 
                onClick={() => setShowModal(false)}
                className="p-2 hover:bg-gray-100 rounded-md transition-colors"
              >
                <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Body - Scrollable */}
            <form onSubmit={handleSubmit} className="flex flex-col flex-1 overflow-hidden">
              <div className="p-6 space-y-4 overflow-y-auto flex-1">
                
                {/* Info : Bannière Staff */}
                <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border-2 border-blue-200 rounded-md p-4">
                  <div className="flex items-start gap-3">
                    <svg className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <div className="text-sm">
                      <p className="font-semibold text-blue-900 mb-1">📢 Bannière Staff</p>
                      <p className="text-blue-700">
                        Cette bannière sera publiée en tant que <strong>{user?.nom} {user?.prenom}</strong> (Staff) 
                        et s'affichera dans la section publicité du dashboard public.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Type de client */}
                <div className="border-2 border-gray-200 rounded-md p-4 bg-gray-50">
                  <label className="block text-sm font-medium text-gray-700 mb-3">
                    Type de client <span className="text-red-500">*</span>
                  </label>
                  <div className="flex gap-6">
                    <label className="flex items-center cursor-pointer">
                      <input
                        type="radio"
                        value="existing"
                        checked={formData.client_type === 'existing'}
                        onChange={(e) => setFormData({ ...formData, client_type: e.target.value })}
                        className="w-4 h-4 text-[#B8860B] focus:ring-amber-200"
                      />
                      <span className="ml-2 text-gray-700">Client existant</span>
                    </label>
                    <label className="flex items-center cursor-pointer">
                      <input
                        type="radio"
                        value="external"
                        checked={formData.client_type === 'external'}
                        onChange={(e) => setFormData({ ...formData, client_type: e.target.value })}
                        className="w-4 h-4 text-[#B8860B] focus:ring-amber-200"
                      />
                      <span className="ml-2 text-gray-700">Client externe (sans compte)</span>
                    </label>
                  </div>
                </div>

                {/* Sélection du client existant */}
                {formData.client_type === 'existing' && (
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Sélectionner le client
                    </label>
                    <select
                      value={formData.client_id}
                      onChange={(e) => setFormData({ ...formData, client_id: e.target.value })}
                      className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-amber-200 focus:border-transparent"
                    >
                      <option value="">Moi-même (Admin connecté)</option>
                      {clients.map(client => (
                        <option key={client.client_id} value={client.client_id}>
                          {client.nom} {client.prenom} - {client.email}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                {/* Informations client externe */}
                {formData.client_type === 'external' && (
                  <div className="space-y-4 border-2 border-orange-200 rounded-md p-4 bg-orange-50">
                    <div className="flex items-center gap-2 text-orange-700 mb-2">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                      </svg>
                      <span className="font-semibold">Informations du client externe</span>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Nom complet <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        value={formData.external_client_name}
                        onChange={(e) => setFormData({ ...formData, external_client_name: e.target.value })}
                        className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-amber-200 focus:border-transparent"
                        placeholder="Ex: Jean Dupont"
                        required={formData.client_type === 'external'}
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Numéro de téléphone <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="tel"
                        value={formData.external_client_phone}
                        onChange={(e) => setFormData({ ...formData, external_client_phone: e.target.value })}
                        className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-amber-200 focus:border-transparent"
                        placeholder="Ex: +225 07 XX XX XX XX"
                        required={formData.client_type === 'external'}
                      />
                    </div>
                  </div>
                )}

                {/* Titre */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Titre de la bannière <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    value={formData.title}
                    onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                    className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-amber-200 focus:border-transparent"
                    placeholder="Ex: Promotion Spéciale - Boutique XYZ"
                    required
                  />
                </div>

                {/* Description */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Description <span className="text-red-500">*</span>
                  </label>
                  <textarea
                    value={formData.description}
                    onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                    rows={3}
                    className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-amber-200 focus:border-transparent"
                    placeholder="Description de la bannière publicitaire..."
                    required
                  />
                </div>

                {/* URL du site et Position */}
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      URL du site web
                    </label>
                    <input
                      type="url"
                      value={formData.website_url}
                      onChange={(e) => setFormData({ ...formData, website_url: e.target.value })}
                      className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-amber-200 focus:border-transparent"
                      placeholder="https://example.com"
                    />
                    <p className="mt-1 text-xs text-gray-500">
                      Site vers lequel la bannière redirige
                    </p>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Position <span className="text-red-500">*</span>
                    </label>
                    <select
                      value={formData.position}
                      onChange={(e) => setFormData({ ...formData, position: e.target.value })}
                      className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-amber-200 focus:border-transparent bg-white"
                      required
                    >
                      <option value="1">Position 1 (Haut)</option>
                      <option value="2">Position 2</option>
                      <option value="3">Position 3</option>
                      <option value="4">Position 4</option>
                      <option value="5">Position 5 (Bas)</option>
                    </select>
                  </div>
                </div>

                {/* Durée d'affichage */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Durée d'affichage (jours) <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="number"
                    value={formData.duration}
                    onChange={(e) => setFormData({ ...formData, duration: e.target.value })}
                    className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-amber-200 focus:border-transparent"
                    placeholder="Ex: 30"
                    min="1"
                    max="365"
                    required
                  />
                  <p className="mt-1 text-xs text-gray-500">
                    Nombre de jours pendant lesquels la bannière sera visible (1-365 jours)
                  </p>
                </div>

                {/* Image */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Image de la bannière <span className="text-red-500">*</span>
                  </label>
                  
                  {/* Note sur les dimensions */}
                  <div className="mb-3 p-4 bg-gradient-to-r from-blue-50 to-indigo-50 border-2 border-blue-200 rounded-md">
                    <div className="flex items-start gap-3">
                      <svg className="w-6 h-6 text-blue-600 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      <div>
                        <p className="text-sm font-bold text-blue-900 mb-2">📐 Dimensions du bloc d'affichage</p>
                        <div className="text-xs text-blue-800 space-y-1">
                          <p>• <strong>Largeur :</strong> 320px (fixe)</p>
                          <p>• <strong>Hauteur :</strong> 192px (fixe)</p>
                          <p>• <strong>Ratio :</strong> 5:3 (paysage)</p>
                        </div>
                        <p className="text-xs text-blue-600 mt-2 italic">
                          ⚠️ Format recommandé : 640×384px ou 960×576px pour une qualité optimale
                        </p>
                        <p className="text-xs text-gray-600 mt-1">
                          💡 Note : Le bloc est masqué sur mobile/tablette et visible uniquement sur desktop
                        </p>
                      </div>
                    </div>
                  </div>
                  
                  {/* Input file */}
                  <input
                    type="file"
                    onChange={handleImageChange}
                    accept="image/*"
                    className="hidden"
                    id="banner-image-upload"
                    required={!formData.image}
                  />

                  {formData.image ? (
                    <div className="relative">
                      <div className="relative rounded-md overflow-hidden border-2 border-dashed border-[#F5B700] bg-white border border-slate-200">
                        <img
                          src={URL.createObjectURL(formData.image)}
                          alt="Aperçu bannière"
                          className="w-full h-48 object-cover"
                        />
                      </div>
                      <button
                        type="button"
                        onClick={() => setFormData({ ...formData, image: null })}
                        className="absolute top-2 right-2 w-8 h-8 bg-red-500 hover:bg-red-600 rounded-full flex items-center justify-center shadow-lg transition-colors"
                      >
                        <svg className="w-4 h-4 text-[#002A4E]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                      </button>
                    </div>
                  ) : (
                    <div
                      onClick={() => document.getElementById('banner-image-upload').click()}
                      className="border-2 border-dashed border-gray-300 rounded-md p-8 text-center cursor-pointer hover:border-[#F5B700] hover:bg-[#FFD700]/5 transition-all"
                    >
                      <div className="flex flex-col items-center gap-2">
                        <div className="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center">
                          <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                          </svg>
                        </div>
                        <p className="text-sm text-gray-600 font-medium">Cliquez pour ajouter une image</p>
                        <p className="text-xs text-gray-500">Format recommandé: 1200x300px</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Footer - Fixed */}
              <div className="flex justify-end gap-3 p-6 border-t border-gray-200 bg-gray-50 rounded-b-md flex-shrink-0">
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  className="px-8 py-3 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-100 transition-colors font-medium"
                >
                  Annuler
                </button>
                <button
                  type="submit"
                  className="px-8 py-3 bg-gradient-to-r from-[#FFD700] to-[#F5C800] text-[#002A4E] rounded-md transition-all font-medium"
                >
                  Créer la bannière
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal de modification */}
      {showEditModal && selectedBanner && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 animate-fadeIn">
          <div className="bg-white rounded-md max-w-3xl w-full max-h-[90vh] flex flex-col animate-scaleIn border border-slate-200">
            {/* Header - Fixed */}
            <div className="p-6 border-b border-gray-200 flex items-center justify-between flex-shrink-0 rounded-t-md">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-gradient-to-br from-green-500 to-green-600 rounded-md flex items-center justify-center">
                  <svg className="w-6 h-6 text-[#002A4E]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                  </svg>
                </div>
                <h2 className="text-2xl font-bold text-gray-800">Modifier la bannière</h2>
              </div>
              <button 
                onClick={() => {
                  setShowEditModal(false)
                  setSelectedBanner(null)
                }}
                className="p-2 hover:bg-gray-100 rounded-md transition-colors"
              >
                <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Body - Scrollable */}
            <form onSubmit={handleUpdate} className="flex flex-col flex-1 overflow-hidden">
              <div className="p-6 space-y-4 overflow-y-auto flex-1">
                
                {/* Type de client */}
                <div className="border-2 border-gray-200 rounded-md p-4 bg-gray-50">
                  <label className="block text-sm font-medium text-gray-700 mb-3">
                    Type de client <span className="text-red-500">*</span>
                  </label>
                  <div className="flex gap-6">
                    <label className="flex items-center cursor-pointer">
                      <input
                        type="radio"
                        value="existing"
                        checked={formData.client_type === 'existing'}
                        onChange={(e) => setFormData({ ...formData, client_type: e.target.value })}
                        className="w-4 h-4 text-green-600 focus:ring-green-500"
                      />
                      <span className="ml-2 text-gray-700">Client existant</span>
                    </label>
                    <label className="flex items-center cursor-pointer">
                      <input
                        type="radio"
                        value="external"
                        checked={formData.client_type === 'external'}
                        onChange={(e) => setFormData({ ...formData, client_type: e.target.value })}
                        className="w-4 h-4 text-green-600 focus:ring-green-500"
                      />
                      <span className="ml-2 text-gray-700">Client externe (sans compte)</span>
                    </label>
                  </div>
                </div>

                {/* Sélection du client existant */}
                {formData.client_type === 'existing' && (
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Sélectionner le client
                    </label>
                    <select
                      value={formData.client_id}
                      onChange={(e) => setFormData({ ...formData, client_id: e.target.value })}
                      className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-green-500 focus:border-transparent"
                    >
                      <option value="">Moi-même (Admin connecté)</option>
                      {clients.map(client => (
                        <option key={client.client_id} value={client.client_id}>
                          {client.nom} {client.prenom} - {client.email}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                {/* Informations client externe */}
                {formData.client_type === 'external' && (
                  <div className="space-y-4 border-2 border-orange-200 rounded-md p-4 bg-orange-50">
                    <div className="flex items-center gap-2 text-orange-700 mb-2">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                      </svg>
                      <span className="font-semibold">Informations du client externe</span>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Nom complet <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        value={formData.external_client_name}
                        onChange={(e) => setFormData({ ...formData, external_client_name: e.target.value })}
                        className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-green-500 focus:border-transparent"
                        placeholder="Ex: Jean Dupont"
                        required={formData.client_type === 'external'}
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Numéro de téléphone <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="tel"
                        value={formData.external_client_phone}
                        onChange={(e) => setFormData({ ...formData, external_client_phone: e.target.value })}
                        className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-green-500 focus:border-transparent"
                        placeholder="Ex: +225 07 XX XX XX XX"
                        required={formData.client_type === 'external'}
                      />
                    </div>
                  </div>
                )}

                {/* Titre */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Titre de la bannière <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    value={formData.title}
                    onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                    className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-green-500 focus:border-transparent"
                    placeholder="Ex: Promotion Spéciale - Boutique XYZ"
                    required
                  />
                </div>

                {/* Description */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Description <span className="text-red-500">*</span>
                  </label>
                  <textarea
                    value={formData.description}
                    onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                    rows={3}
                    className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-green-500 focus:border-transparent"
                    placeholder="Description de la bannière publicitaire..."
                    required
                  />
                </div>

                {/* URL du site et Position */}
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      URL du site web
                    </label>
                    <input
                      type="url"
                      value={formData.website_url}
                      onChange={(e) => setFormData({ ...formData, website_url: e.target.value })}
                      className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-green-500 focus:border-transparent"
                      placeholder="https://example.com"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Position <span className="text-red-500">*</span>
                    </label>
                    <select
                      value={formData.position}
                      onChange={(e) => setFormData({ ...formData, position: e.target.value })}
                      className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-green-500 focus:border-transparent"
                      required
                    >
                      <option value="1">Position 1 (Haut)</option>
                      <option value="2">Position 2</option>
                      <option value="3">Position 3</option>
                      <option value="4">Position 4</option>
                      <option value="5">Position 5 (Bas)</option>
                    </select>
                  </div>
                </div>

                {/* Durée */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Durée (en jours) <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="number"
                    value={formData.duration}
                    onChange={(e) => setFormData({ ...formData, duration: e.target.value })}
                    className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-green-500 focus:border-transparent"
                    placeholder="Ex: 30"
                    min="1"
                    max="365"
                    required
                  />
                  <p className="mt-1 text-xs text-gray-500">
                    Nombre de jours pendant lesquels la bannière sera visible (1-365 jours)
                  </p>
                </div>

                {/* Image */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Changer l'image (optionnel)
                  </label>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleImageChange}
                    className="hidden"
                    id="edit-banner-image"
                  />
                  
                  {formData.image ? (
                    <div className="relative">
                      <div className="relative rounded-md overflow-hidden border-2 border-dashed border-green-500 bg-white border border-slate-200">
                        <img
                          src={URL.createObjectURL(formData.image)}
                          alt="Aperçu bannière"
                          className="w-full h-48 object-cover"
                        />
                      </div>
                      <button
                        type="button"
                        onClick={() => setFormData({ ...formData, image: null })}
                        className="absolute top-2 right-2 w-8 h-8 bg-red-500 hover:bg-red-600 rounded-full flex items-center justify-center shadow-lg transition-colors"
                      >
                        <svg className="w-4 h-4 text-[#002A4E]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                      </button>
                    </div>
                  ) : selectedBanner?.image ? (
                    <label htmlFor="edit-banner-image" className="block relative rounded-md overflow-hidden border-2 border-dashed border-blue-300 cursor-pointer">
                      <img src={selectedBanner.image} alt="Image actuelle" className="w-full h-48 object-cover opacity-80" />
                      <div className="absolute inset-0 bg-black/30 flex items-center justify-center">
                        <span className="text-[#002A4E] text-sm font-medium bg-black/50 px-3 py-1 rounded-full">Cliquer pour changer</span>
                      </div>
                    </label>
                  ) : (
                    <label
                      htmlFor="edit-banner-image"
                      className="block w-full px-4 py-8 border-2 border-dashed border-gray-300 rounded-md hover:border-green-400 transition-colors cursor-pointer"
                    >
                      <div className="flex flex-col items-center gap-2">
                        <div className="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center">
                          <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                          </svg>
                        </div>
                        <p className="text-sm text-gray-600 font-medium">Cliquez pour changer l'image</p>
                        <p className="text-xs text-gray-500">Laissez vide pour garder l'image actuelle</p>
                      </div>
                    </label>
                  )}
                </div>
              </div>

              {/* Footer - Fixed */}
              <div className="flex justify-end gap-3 p-6 border-t border-gray-200 bg-gray-50 rounded-b-md flex-shrink-0">
                <button
                  type="button"
                  onClick={() => {
                    setShowEditModal(false)
                    setSelectedBanner(null)
                  }}
                  className="px-8 py-3 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-100 transition-colors font-medium"
                >
                  Annuler
                </button>
                <button
                  type="submit"
                  className="px-8 py-3 bg-gradient-to-r from-green-500 to-green-600 text-[#002A4E] rounded-md transition-all font-medium"
                >
                  Enregistrer les modifications
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal Voir les détails */}
      {showViewModal && selectedBanner && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4 animate-fadeIn backdrop-blur-sm">
          <div className="bg-white rounded-md max-w-4xl w-full max-h-[90vh] flex flex-col animate-scaleIn border border-slate-200">
            {/* Header */}
            <div className="px-8 py-6 bg-blue-50/50 border-b-2 border-blue-100 rounded-t-md flex items-center justify-between flex-shrink-0">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-blue-100 rounded-md flex items-center justify-center">
                  <svg className="w-7 h-7 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                  </svg>
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-blue-600">Détails de la bannière</h2>
                  <p className="text-blue-500 text-sm mt-0.5">Informations complètes de la bannière publicitaire</p>
                </div>
              </div>
              <button 
                onClick={() => {
                  setShowViewModal(false)
                  setSelectedBanner(null)
                }}
                className="p-2 hover:bg-blue-50 rounded-md transition-all duration-200"
              >
                <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Body */}
            <div className="p-8 space-y-6 overflow-y-auto flex-1 bg-gray-50">
              {/* Image de la bannière */}
              {selectedBanner.image_url && (
                <div className="bg-white rounded-md p-6 border border-slate-200">
                  <div className="flex items-center gap-2 mb-4">
                    <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                    <h3 className="text-lg font-bold text-gray-800">Image de la bannière</h3>
                  </div>
                  <img 
                    src={`http://localhost/ligdi/public/${selectedBanner.image_url}`}
                    alt={selectedBanner.title || selectedBanner.titre}
                    className="w-full h-64 object-cover rounded-md border-2 border-gray-200 "
                    onError={(e) => {
                      e.target.style.display = 'none'
                    }}
                  />
                </div>
              )}

              {/* Informations principales */}
              <div className="bg-white rounded-md p-6 border border-slate-200">
                <div className="flex items-center gap-2 mb-6">
                  <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <h3 className="text-lg font-bold text-gray-800">Informations générales</h3>
                </div>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="bg-gradient-to-br from-blue-50 to-blue-100/50 rounded-md p-4 border border-blue-200">
                    <label className="text-xs font-semibold text-blue-600 uppercase tracking-wide">Titre</label>
                    <p className="text-base font-bold text-gray-900 mt-2">{selectedBanner.title || selectedBanner.titre || 'Sans titre'}</p>
                  </div>
                  
                  <div className="bg-gradient-to-br from-purple-50 to-purple-100/50 rounded-md p-4 border border-purple-200">
                    <label className="text-xs font-semibold text-purple-600 uppercase tracking-wide">Durée</label>
                    <p className="mt-2">
                      {selectedBanner.starts_at && selectedBanner.expires_at ? (() => {
                        const startDate = new Date(selectedBanner.starts_at);
                        const endDate = new Date(selectedBanner.expires_at);
                        const diffTime = endDate - startDate;
                        const totalDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                        return (
                          <span className="inline-flex items-center gap-2 px-4 py-2 bg-purple-600 text-white rounded-md text-sm font-semibold ">
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            {totalDays} jour{totalDays > 1 ? 's' : ''}
                          </span>
                        );
                      })() : <span className="text-sm text-gray-400">N/A</span>}
                    </p>
                  </div>
                  
                  <div className="bg-gradient-to-br from-orange-50 to-orange-100/50 rounded-md p-4 border border-orange-200">
                    <label className="text-xs font-semibold text-orange-600 uppercase tracking-wide">Annonceur</label>
                    <p className="text-base font-semibold text-gray-900 mt-2">{selectedBanner.advertiser || 'N/A'}</p>
                    {selectedBanner.advertiser_phone && (
                      <p className="text-sm text-gray-600 mt-1 flex items-center gap-1">
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                        </svg>
                        {selectedBanner.advertiser_phone}
                      </p>
                    )}
                  </div>
                  
                  <div className="bg-gradient-to-br from-green-50 to-green-100/50 rounded-md p-4 border border-green-200">
                    <label className="text-xs font-semibold text-green-600 uppercase tracking-wide">Statut</label>
                    <p className="mt-2">
                      {selectedBanner.status === 2 ? (
                        <span className="inline-flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-md text-sm font-semibold ">
                          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                          </svg>
                          Active
                        </span>
                      ) : selectedBanner.status === 3 ? (
                        <span className="inline-flex items-center gap-2 px-4 py-2 bg-gray-600 text-white rounded-md text-sm font-semibold ">
                          Archivée
                        </span>
                      ) : (
                        <span className="inline-flex items-center gap-2 px-4 py-2 bg-red-600 text-white rounded-md text-sm font-semibold ">
                          Expirée
                        </span>
                      )}
                    </p>
                  </div>
                </div>

                {/* Description */}
                <div className="mt-6 bg-gradient-to-br from-gray-50 to-gray-100/50 rounded-md p-4 border border-gray-200">
                  <label className="text-xs font-semibold text-gray-600 uppercase tracking-wide">Description</label>
                  <p className="text-sm text-gray-700 mt-2 leading-relaxed">{selectedBanner.description || 'Aucune description'}</p>
                </div>

                {/* Site web */}
                {(selectedBanner.website_url || selectedBanner.lien_url) && (
                  <div className="mt-4 bg-gradient-to-br from-indigo-50 to-indigo-100/50 rounded-md p-4 border border-indigo-200">
                    <label className="text-xs font-semibold text-indigo-600 uppercase tracking-wide">Site web</label>
                    <a 
                      href={selectedBanner.website_url || selectedBanner.lien_url}
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-sm text-indigo-600 hover:text-indigo-700 mt-2 flex items-center gap-2 font-medium"
                    >
                      {selectedBanner.website_url || selectedBanner.lien_url}
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                      </svg>
                    </a>
                  </div>
                )}
              </div>

              {/* Statistiques */}
              <div className="bg-white rounded-md p-6 border border-slate-200">
                <div className="flex items-center gap-2 mb-4">
                  <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                  </svg>
                  <h3 className="text-lg font-bold text-gray-800">Performance & Dates</h3>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div className="bg-gradient-to-br from-cyan-50 to-cyan-100/50 rounded-md p-4 border border-cyan-200">
                    <label className="text-xs font-semibold text-cyan-600 uppercase tracking-wide">Vues</label>
                    <p className="text-2xl font-bold text-cyan-700 mt-2">{selectedBanner.views || 0}</p>
                  </div>
                  <div className="bg-gradient-to-br from-teal-50 to-teal-100/50 rounded-md p-4 border border-teal-200">
                    <label className="text-xs font-semibold text-teal-600 uppercase tracking-wide">Date de création</label>
                    <p className="text-sm font-semibold text-gray-900 mt-2">
                      {selectedBanner.created_at ? new Date(selectedBanner.created_at).toLocaleDateString('fr-FR', {
                        day: 'numeric',
                        month: 'long',
                        year: 'numeric'
                      }) : 'N/A'}
                    </p>
                  </div>
                  <div className="bg-gradient-to-br from-yellow-50 to-yellow-100/50 rounded-md p-4 border border-yellow-200">
                    <label className="text-xs font-semibold text-yellow-600 uppercase tracking-wide">Date d'expiration</label>
                    <p className="text-sm font-semibold text-gray-900 mt-2">
                      {selectedBanner.expires_at ? new Date(selectedBanner.expires_at).toLocaleDateString('fr-FR', {
                        day: 'numeric',
                        month: 'long',
                        year: 'numeric'
                      }) : 'N/A'}
                    </p>
                  </div>
                </div>
                
                {/* Jours restants */}
                {selectedBanner.expires_at && (
                  <div className="mt-4 bg-gradient-to-br from-rose-50 to-rose-100/50 rounded-md p-4 border border-rose-200">
                    <label className="text-xs font-semibold text-rose-600 uppercase tracking-wide">Jours restants</label>
                    <p className="mt-2">
                      {(() => {
                        const now = new Date();
                        const expiryDate = new Date(selectedBanner.expires_at);
                        const diffTime = expiryDate - now;
                        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
                        
                        if (diffDays < 0) {
                          return <span className="inline-flex items-center gap-2 px-4 py-2 bg-red-600 text-white rounded-md text-sm font-semibold">Expirée</span>;
                        } else if (diffDays === 0) {
                          return <span className="inline-flex items-center gap-2 px-4 py-2 bg-orange-600 text-white rounded-md text-sm font-semibold">Expire aujourd'hui</span>;
                        } else if (diffDays === 1) {
                          return <span className="inline-flex items-center gap-2 px-4 py-2 bg-orange-600 text-white rounded-md text-sm font-semibold">1 jour restant</span>;
                        } else {
                          return <span className="inline-flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-md text-sm font-semibold">{diffDays} jours restants</span>;
                        }
                      })()}
                    </p>
                  </div>
                )}
              </div>
            </div>

            {/* Footer */}
            <div className="p-6 border-t border-gray-200 bg-gray-50 rounded-b-md flex-shrink-0">
              <button
                onClick={() => {
                  setShowViewModal(false)
                  setSelectedBanner(null)
                }}
                className="px-6 py-2.5 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-md transition-all font-medium"
              >
                Fermer
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de suppression */}
      {/* Modal de confirmation d'archivage/désarchivage */}
      {showArchiveModal && selectedBanner && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 animate-fadeIn">
          <div className="bg-white rounded-md max-w-md w-full animate-scaleIn border border-slate-200">
            <div className="p-6 border-b border-gray-200">
              <div className="flex items-center gap-3">
                <div className={`w-12 h-12 ${selectedBanner.status === 3 ? 'bg-green-100' : 'bg-orange-100'} rounded-full flex items-center justify-center`}>
                  {selectedBanner.status === 3 ? (
                    <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                    </svg>
                  ) : (
                    <svg className="w-6 h-6 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" />
                    </svg>
                  )}
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-800">
                    {selectedBanner.status === 3 ? 'Désarchiver' : 'Archiver'} la bannière
                  </h3>
                  <p className="text-sm text-gray-500 mt-1">
                    {selectedBanner.status === 3 ? 'Rendre visible à nouveau' : 'Masquer temporairement'}
                  </p>
                </div>
              </div>
            </div>

            <div className="p-6">
              <p className="text-gray-700 mb-4">
                {selectedBanner.status === 3 
                  ? 'Cette bannière sera à nouveau visible sur la plateforme.'
                  : 'Cette bannière sera masquée mais pourra être restaurée plus tard.'}
              </p>
              <div className="bg-gray-50 rounded-md p-4 border border-gray-200">
                <p className="font-semibold text-gray-800">{selectedBanner.title || selectedBanner.titre}</p>
                <p className="text-sm text-gray-600 mt-1">{selectedBanner.advertiser || 'N/A'}</p>
              </div>
            </div>

            <div className="p-6 border-t border-gray-200 bg-gray-50 rounded-b-md flex gap-3">
              <button
                onClick={() => {
                  setShowArchiveModal(false)
                  setSelectedBanner(null)
                  setArchiveAction(null)
                }}
                className="flex-1 px-6 py-3 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-100 transition-colors font-medium"
              >
                Annuler
              </button>
              <button
                onClick={confirmArchive}
                className={`flex-1 px-6 py-3 bg-gradient-to-r ${selectedBanner.status === 3 ? 'from-green-500 to-green-600' : 'from-orange-500 to-orange-600'} text-white rounded-md transition-all font-medium`}
              >
                Oui, {selectedBanner.status === 3 ? 'désarchiver' : 'archiver'}
              </button>
            </div>
          </div>
        </div>
      )}

      {showDeleteModal && selectedBanner && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 animate-fadeIn">
          <div className="bg-white rounded-md max-w-md w-full animate-scaleIn border border-slate-200">
            <div className="p-6">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900">Supprimer la bannière</h3>
                  <p className="text-sm text-gray-500 mt-1">Cette action est irréversible</p>
                </div>
              </div>
              
              <p className="text-gray-700 mb-4">
                Êtes-vous sûr de vouloir supprimer la bannière <span className="font-semibold">"{selectedBanner.title || selectedBanner.name}"</span> ? Cette action ne peut pas être annulée.
              </p>
              
              <div className="bg-gray-50 rounded-md p-4 border border-gray-200 mb-6">
                <p className="font-semibold text-gray-800">{selectedBanner.title || selectedBanner.titre}</p>
                <p className="text-sm text-gray-600 mt-1">{selectedBanner.advertiser || 'N/A'}</p>
              </div>
              
              <div className="flex justify-end gap-3">
                <button
                  onClick={() => {
                    setShowDeleteModal(false)
                    setSelectedBanner(null)
                  }}
                  className="px-8 py-3 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors font-medium"
                >
                  Annuler
                </button>
                <button
                  onClick={handleDelete}
                  className="px-8 py-3 bg-red-600 hover:bg-red-700 text-white rounded-md transition-colors font-medium"
                >
                  Supprimer
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </AdminLayout>
  )
}

export default AdminBannersPage
